/*! Korner Halloween 2026 — unpublished theme inject (mega untouched) */
(function () {
  'use strict';
  if (window.__kornerHalloween2026) return;
  window.__kornerHalloween2026 = true;

  var STICKY_KEY = 'kh_sticky_dismissed';
  var FLIGHT_KEY = 'kh_flight_dismissed_v7'; // Owen 2026-10-24: bump 救 flying＋關特效

  function svg(id, cls, view) {
    view = view || '0 0 80 80';
    cls = cls || '';
    return '<svg class="' + cls + '" aria-hidden="true" focusable="false" viewBox="' + view + '"><use href="#' + id + '"></use></svg>';
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function isStickyDismissed() {
    try { return sessionStorage.getItem(STICKY_KEY) === '1'; } catch (e) { return false; }
  }

  function setStickyDismissed() {
    try { sessionStorage.setItem(STICKY_KEY, '1'); } catch (e) {}
    document.documentElement.classList.add('kh-sticky-dismissed');
  }


  function isFlightDismissed() {
    try { return sessionStorage.getItem(FLIGHT_KEY) === '1'; } catch (e) { return false; }
  }

  function setFlightDismissed() {
    try { sessionStorage.setItem(FLIGHT_KEY, '1'); } catch (e) {}
    document.documentElement.classList.add('kh-flight-dismissed');
  }

  function clearFlightDismissed() {
    try { sessionStorage.removeItem(FLIGHT_KEY); } catch (e) {}
    document.documentElement.classList.remove('kh-flight-dismissed');
  }

  function applyFlightDismissState() {
    if (isFlightDismissed()) {
      document.documentElement.classList.add('kh-flight-dismissed');
      return true;
    }
    document.documentElement.classList.remove('kh-flight-dismissed');
    return false;
  }

  function updateFlightChip(btn) {
    if (!btn) return;
    var on = !isFlightDismissed();
    var txt = btn.querySelector('.kh-flight-close-txt');
    if (txt) txt.textContent = on ? '關特效' : '開特效';
    btn.setAttribute('aria-label', on ? '關閉蝙蝠特效' : '開啟蝙蝠特效');
    btn.setAttribute('title', on ? '關特效' : '開特效');
    btn.classList.toggle('is-off', !on);
  }

  function applyStickyDismissState() {
    if (isStickyDismissed()) {
      document.documentElement.classList.add('kh-sticky-dismissed');
      document.documentElement.style.setProperty('--kh-sticky-promo-h', '0px');
      var spacer = document.querySelector('.kh-sticky-promo-spacer');
      if (spacer) spacer.style.height = '0px';
      return true;
    }
    return false;
  }

  function layoutStickyPromo() {
    if (applyStickyDismissState()) return;
    var header = document.querySelector('.owen-site-header');
    var promo = document.querySelector('.kh-sticky-promo');
    var spacer = document.querySelector('.kh-sticky-promo-spacer');
    if (!promo) return;
    var hh = header ? header.offsetHeight : 72;
    document.documentElement.style.setProperty('--kh-site-header-h', hh + 'px');
    var ph = promo.offsetHeight || 30;
    document.documentElement.style.setProperty('--kh-sticky-promo-h', ph + 'px');
    if (spacer) {
      spacer.style.height = ph + 'px';
      var host = document.querySelector('.owen-header-spacer');
      if (host && spacer.parentElement !== host.parentElement) {
        host.insertAdjacentElement('afterend', spacer);
      } else if (host && spacer.previousElementSibling !== host) {
        host.insertAdjacentElement('afterend', spacer);
      }
    }
  }

  ready(function () {
    applyStickyDismissState();
    applyFlightDismissState();

    // Logo: keep orange CSS filter only — no witch hat (Owen 2026-10-23)

    // Top bar pumpkin + bat flanking first visible bar-inner
    var barInner = document.querySelector('[id^="owen-promotion-"] .owen-bar-inner') ||
      document.querySelector('[id^="owen-permanent-"] .owen-bar-inner') ||
      document.querySelector('[id^="owen-topbar-"] .owen-bar-inner');
    if (barInner && !barInner.querySelector('.kh-top-pumpkin')) {
      barInner.classList.add('kh-top-inner');
      barInner.insertAdjacentHTML('afterbegin', '<span class="kh-top-pumpkin" aria-hidden="true">' + svg('kh-pumpkin') + '</span>');
      barInner.insertAdjacentHTML('beforeend', '<span class="kh-top-bat" aria-hidden="true">' + svg('kh-bat', '', '0 0 100 55') + '</span>');
    }

    // Hero decor on media gallery / first banner
    var hero = document.querySelector('.mg') ||
      document.querySelector('[id*="media_gallery"] .mg') ||
      document.querySelector('.banner-image') ||
      document.querySelector('[class*="media-gallery"]');
    if (hero && !hero.querySelector('.kh-hero-decor')) {
      hero.classList.add('kh-hero');
      if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
      hero.insertAdjacentHTML(
        'beforeend',
        '<div class="kh-hero-decor" aria-hidden="true">' +
          /* Owen 2026-10-24: 只唔要中間 mid；左右 corner／頂欄／細粒飄留 */
          svg('kh-pumpkin', 'kh-corner-pumpkin') +
          svg('kh-pumpkin', 'kh-corner-pumpkin kh-right') +
          svg('kh-candy', 'kh-corner-candy', '0 0 35 50') +
          svg('kh-bat', 'kh-hero-bat', '0 0 100 55') +
          ['s1', 's2', 's3'].map(function (c) { return '<svg class="kh-star ' + c + '" viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path d="M16 1l4 11 11 4-11 4-4 11-4-11-11-4 11-4z" fill="#ed9c43"></path></svg>'; }).join('') +
        '</div>'
      );
    }

    var closeBtn = document.querySelector('.kh-sticky-promo-close');
    if (closeBtn && !closeBtn.__khBound) {
      closeBtn.__khBound = true;
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setStickyDismissed();
        layoutStickyPromo();
      });
    }

    layoutStickyPromo();
    window.addEventListener('resize', layoutStickyPromo);
    if (window.ResizeObserver && document.querySelector('.owen-site-header')) {
      try {
        new ResizeObserver(layoutStickyPromo).observe(document.querySelector('.owen-site-header'));
      } catch (e) {}
    }

    // Flying bats cycle + toggle 關／開特效（sessionStorage 可清，唔永久鎖死）
    // Owen 2026-10-24: 主頁循環照舊；內頁每次開／刷新只出一次、飛快少少、滑下自動關
    var flight = document.querySelector('.kh-flight');
    var flightClose = document.querySelector('.kh-flight-close');
    applyFlightDismissState();
    updateFlightChip(flightClose);

    function isHomePage() {
      var p = (location.pathname || '/').replace(/\/+$/, '') || '/';
      var bare = p.replace(/^\/(zh|en|ja|ko)(-[a-z]{2})?/i, '') || '/';
      return bare === '/' || bare === '';
    }

    var onHome = isHomePage();
    document.body.classList.toggle('kh-home', onHome);
    document.body.classList.toggle('kh-inner', !onHome);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var CYCLE_MS = 10000;
    var repeatTimer;
    var softDismissed = false; // 內頁滑下關：只今次瀏覽，刷新可再出

    function flightOff() {
      return softDismissed || isFlightDismissed() || reduce.matches;
    }

    function playCycle() {
      if (!flight || flightOff() || document.hidden) return;
      document.body.classList.remove('kh-cycle');
      void flight.offsetWidth;
      document.body.classList.add('kh-cycle');
    }
    function syncMotion() {
      clearInterval(repeatTimer);
      repeatTimer = null;
      if (flightOff()) {
        document.body.classList.remove('kh-cycle');
        document.documentElement.classList.toggle('kh-flight-dismissed', softDismissed || isFlightDismissed());
        updateFlightChip(flightClose);
        return;
      }
      document.documentElement.classList.remove('kh-flight-dismissed');
      if (!flight) return;
      playCycle();
      // 主頁循環；內頁每次開／刷新只播一輪
      if (onHome) {
        repeatTimer = setInterval(playCycle, CYCLE_MS);
      }
    }

    function softDismissFlight() {
      if (onHome || softDismissed) return;
      softDismissed = true;
      document.body.classList.remove('kh-cycle');
      document.documentElement.classList.add('kh-flight-dismissed');
      updateFlightChip(flightClose);
      clearInterval(repeatTimer);
      repeatTimer = null;
    }

    // patch chip: softDismiss 時當關，開特效可清 soft
    var _updateFlightChip = updateFlightChip;
    updateFlightChip = function (btn) {
      if (!btn) return;
      var on = !(softDismissed || isFlightDismissed());
      var txt = btn.querySelector('.kh-flight-close-txt');
      if (txt) txt.textContent = on ? '關特效' : '開特效';
      btn.setAttribute('aria-label', on ? '關閉蝙蝠特效' : '開啟蝙蝠特效');
      btn.setAttribute('title', on ? '關特效' : '開特效');
      btn.classList.toggle('is-off', !on);
    };

    if (flightClose && !flightClose.__khBound) {
      flightClose.__khBound = true;
      flightClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (softDismissed || isFlightDismissed()) {
          softDismissed = false;
          clearFlightDismissed();
          updateFlightChip(flightClose);
          syncMotion();
        } else {
          softDismissed = false;
          setFlightDismissed();
          document.body.classList.remove('kh-cycle');
          updateFlightChip(flightClose);
        }
      });
    }

    if (!onHome) {
      var scrollBound = false;
      window.addEventListener('scroll', function () {
        if (scrollBound || softDismissed || isFlightDismissed()) return;
        if ((window.scrollY || document.documentElement.scrollTop || 0) < 72) return;
        scrollBound = true;
        softDismissFlight();
      }, { passive: true });
    }

    syncMotion();
    if (reduce.addEventListener) reduce.addEventListener('change', syncMotion);
    else if (reduce.addListener) reduce.addListener(syncMotion);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncMotion();
    });
  });
})();
